import { render, staticRenderFns } from "./LgbTeamMembersList.vue?vue&type=template&id=392aad5e"
import script from "./LgbTeamMembersList.vue?vue&type=script&lang=js"
export * from "./LgbTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./LgbTeamMembersList.vue?vue&type=style&index=0&id=392aad5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports